import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { BrandLockup } from "@/components/BrandLockup";

const LOCKED = process.env.REACT_APP_SITE_LOCKED === "true";
const PASSWORD = process.env.REACT_APP_ACCESS_PASSWORD || "";

export default function AccessGate({ children }) {
  const navigate = useNavigate();
  const [ok, setOk] = useState(() => localStorage.getItem("bme_gate_ok") === "1");
  const [pw, setPw] = useState("");
  const [error, setError] = useState(false);

  if (!LOCKED || ok) return children;

  const submit = (e) => {
    e.preventDefault();
    if (PASSWORD && pw.trim() === PASSWORD) {
      localStorage.setItem("bme_gate_ok", "1");
      setOk(true);
      navigate("/");
    } else {
      setError(true);
    }
  };

  return (
    <div
      data-testid="access-gate"
      className="min-h-screen grid place-items-center px-6 py-14"
      style={{ background: "radial-gradient(1100px 600px at 50% -10%, #fde7ec 0%, #ffffff 55%)" }}
    >
      <div className="w-full max-w-sm text-center">
        <div className="flex justify-center mb-8">
          <BrandLockup />
        </div>
        <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-6">
          <Lock className="h-3.5 w-3.5" /> Private access
        </div>
        <h1 className="font-display font-extrabold text-2xl tracking-tight text-stone-900">
          Enter password to continue
        </h1>
        <p className="text-muted-foreground mt-2 text-sm">
          This site is private. Please enter the access password.
        </p>

        <form onSubmit={submit} className="mt-8 text-left">
          <input
            data-testid="access-password-input"
            type="password"
            autoFocus
            value={pw}
            onChange={(e) => { setPw(e.target.value); setError(false); }}
            placeholder="Password"
            className="w-full h-12 rounded-xl border border-input bg-white px-4 text-base outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition"
          />
          {error && (
            <p data-testid="access-error" className="text-sm text-destructive mt-2 text-center">
              Incorrect password. Please try again.
            </p>
          )}
          <button
            data-testid="access-submit"
            type="submit"
            className="mt-4 w-full h-12 bg-primary text-white rounded-full font-semibold flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors"
          >
            Enter <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
